var c = Object.defineProperty;
var h = (s, e, t) => e in s ? c(s, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : s[e] = t;
var a = (s, e, t) => h(s, typeof e != "symbol" ? e + "" : e, t);
const i = "default";
class l {
  constructor(e) {
    a(this, "instance");
    this.instance = e;
  }
  async get() {
    this.instance.failIfNotAuthenticated();
    const e = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}`
    });
    return this.handleResponse(e);
  }
  async identify(e = {}) {
    this.instance.failIfNotAuthenticated();
    const t = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}`,
      params: e
    });
    return this.handleResponse(t);
  }
  async getAllPreferences() {
    this.instance.failIfNotAuthenticated();
    const e = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}/preferences`
    });
    return this.handleResponse(e);
  }
  async getPreferences(e = {}) {
    this.instance.failIfNotAuthenticated();
    const t = e.preferenceSet || i, n = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}/preferences/${t}`,
      params: { tenant: e.tenant }
    });
    return this.handleResponse(n);
  }
  async setPreferences(e, t = {}) {
    this.instance.failIfNotAuthenticated();
    const n = t.preferenceSet || i, r = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/preferences/${n}`,
      data: e
    });
    return this.handleResponse(r);
  }
  async getChannelData(e) {
    this.instance.failIfNotAuthenticated();
    const t = await this.instance.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.instance.userId}/channel_data/${e.channelId}`
    });
    return this.handleResponse(t);
  }
  async setChannelData({
    channelId: e,
    channelData: t
  }) {
    this.instance.failIfNotAuthenticated();
    const n = await this.instance.client().makeRequest({
      method: "PUT",
      url: `/v1/users/${this.instance.userId}/channel_data/${e}`,
      data: { data: t }
    });
    return this.handleResponse(n);
  }
  handleResponse(e) {
    if (e.statusCode === "error")
      throw new Error(e.error || e.body);
    return e.body;
  }
}
export {
  l as default
};
//# sourceMappingURL=index.mjs.map
